module.exports = __webpack_public_path__ + "img/TCALCI_broad_female_99.9e6a636e.png";